import { Currency } from '@zapier/design-system-revenue/src/types';

import { formatPrice } from './formatPrice';
import { formatPriceWithCurrencySymbol } from './formatPriceWithCurrencySymbol';
import { PriceFormattingOptions } from './types';

/**
 * Applies currency multiplier and formats price.
 */
export const formatPriceToBeInCurrency = (
  price: number,
  currency: Currency = {
    icon: 'UnitedStates',
    multiplier: 1,
    name: 'USD',
    symbol: '$',
  },
  includeSymbol: boolean = true,
  formattingOptions?: Partial<PriceFormattingOptions>
) => {
  const adjusted = price * currency.multiplier;

  return includeSymbol
    ? formatPriceWithCurrencySymbol(
        adjusted,
        formattingOptions,
        currency.symbol
      )
    : formatPrice(adjusted, formattingOptions);
};
